import {
  SeatClass,
  RailwayOrderStatus
} from '@link/china-railway/services/types';

export default {
  common: {
    colon: ': ',
    cancel: '取消',
    confirm: '确认'
  },
  date: {
    month: {
      month1: '一月',
      month2: '二月',
      month3: '三月',
      month4: '四月',
      month5: '五月',
      month6: '六月',
      month7: '七月',
      month8: '八月',
      month9: '九月',
      month10: '十月',
      month11: '十一月',
      month12: '十二月'
    },
    weeks: {
      sun: '日',
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六'
    }
  },
  seatClass: {
    [SeatClass.Business]: '商务座',
    [SeatClass.Premium]: '特等座',
    [SeatClass.First]: '一等座',
    [SeatClass.Second]: '二等座'
  },

  confirmBooking: {
    title: '温馨提示',
    description: '确认预订后，不可变更信息。请仔细确认以下信息：',
    preOrderDescription:
      '确认预约后，请提前15天进入【订单详情】页面查看抢票状态，不会通过邮件或短信发送抢票结果。',
    departTime: '出发时间',
    trainNumber: '列车班次',
    seatNumber: '车厢/座位号',
    autoAssign: '自动分配',
    passengerName: '预约姓名',
    ticketCount: '预约数量',
    confirmBook: '确认预订',
    date: '{{month}}月{{day}}日',
    orderSuccess: '预订成功',
    orderFailed: '预订失败, 请稍后再试'
  },
  views: {
    booking: {
      bookingId: '订单 {{id}}'
    },
    railway: {
      details: '订单详情',
      booking: '预订高铁',
      ticketCount: '票数',
      selectDate: '选择乘车日期',
      moreTime: '更多时间',
      bookTicket: '预订车次',
      status: {
        [RailwayOrderStatus.StatusUnspecified]: '未知状态',
        [RailwayOrderStatus.Reserved]: '订票中，请稍后',
        [RailwayOrderStatus.Booked]: '订票中，请稍后',
        [RailwayOrderStatus.Cancelling]: '取消中',
        [RailwayOrderStatus.Cancelled]: '已取消',
        [RailwayOrderStatus.Closed]: '余票不足，请重新订票',
        [RailwayOrderStatus.Issuing]: '订票中，请稍后',
        [RailwayOrderStatus.Issued]: '订票成功，已出票',
        [RailwayOrderStatus.Used]: '已使用'
      },
      usageDate: '使用日期'
    },
    trainList: {
      book: '预订',
      preBook: '预约',
      noTrains: '该时间段暂无车次',
      hour: '小时',
      minute: '分',
      durationFormat: '{{hours}}小时{{minutes}}分',
      ticketsLeft: '余票{{count}}张',
      noTickets: '票已售罄',
      notOnSale: '暂未开售'
    },
    orderDetail: {
      title: '订单详情',
      faq: '常见问题',
      dateTimeFormat: '{{year}}年{{month}}月{{day}}日 {{time}}',
      travelInfo: '出行信息',
      departureTime: '出发时间',
      trainNumber: '列车班次',
      seatNumber: '车厢/座位号',
      passengerName: '预约姓名',
      ticketCount: '预约数量',
      highSpeedTicket: '高铁动车票',
      orderId: '订单ID',
      orderTime: '订单完成时间',
      rebookTicket: '重新订票',
      preOrderStatus: '已预约，{{days}}天后开售',
      saleDate: '开售日期',
      saleDateFormat: '{{year}}年{{month}}月{{day}}日',
      cancelOrder: '取消订单',
      cancelOrderSuccess: '取消订单成功',
      cancelOrderFailed: '取消订单失败，请稍后再试',
      cancelOrderDialog: {
        title: '确定取消订单',
        content: '取消订单后可重新购票',
        confirm: '确认取消',
        cancel: '暂不取消'
      }
    }
  }
};
